import '@emotion/react';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1o4yu40",
  styles: "position:relative;flex-grow:1;width:100%"
} : {
  name: "ix72gj-getContentStyles",
  styles: "position:relative;flex-grow:1;width:100%;label:getContentStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpZWxkQ29udGVudFN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHVyIsImZpbGUiOiJGaWVsZENvbnRlbnRTdHlsZXMudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MsIFNlcmlhbGl6ZWRTdHlsZXMgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmV4cG9ydCBjb25zdCBnZXRDb250ZW50U3R5bGVzID0gKCk6IFNlcmlhbGl6ZWRTdHlsZXMgPT4ge1xuICAgIHJldHVybiBjc3Moe1xuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgZmxleEdyb3c6IDEsXG4gICAgICAgIHdpZHRoOiAnMTAwJScsXG4gICAgfSk7XG59O1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const getContentStyles = () => {
  return _ref;
};

export { getContentStyles };
//# sourceMappingURL=FieldContentStyles.js.map
